import { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import _ from "lodash";

import { baseUnitCreate } from "./createOrder.constants";

import classes from "./createOrder.module.scss";
import { ReactComponent as AddIcon } from "@/assets/images/desktop/agregar.svg";

import CreateOrderTableHead from "./CreateOrderTableHead";
import CreateOrderTableItem from "./CreateOrderTableItem";
import { formatMilesDecimalNew } from "@/services/Utils";
import { useOrderCreate } from "@/hooks/purchases/orders";

const CreateOrderTableDetail = ({ params, data, setData }) => {
	const { data: response } = useOrderCreate(params);
	const { units_measurement } = response;

	const [activeProduct, setActiveProduct] = useState(true);
	const [products, setProducts] = useState([]);
	const [reload, setReload] = useState(true);

	const [net, setNet] = useState(0);

	useEffect(() => {
		if (!response?.products) return;

		if (response.products.length === products.length && products.length > 0) return;

		setProducts(response.products);
		// eslint-disable-next-line
	}, [response?.products]);

	useEffect(() => {
		if (!reload || !data.items?.length) return;

		const newItems = data.items.map((item) => {
			let units = baseUnitCreate;
			const unitMeasurement = item.unit_measurement === "c" ? "cc" : item.unit_measurement;

			const itemUnit = units_measurement?.filter((um) => um.base_unit === unitMeasurement);
			if (itemUnit?.length) {
				units = itemUnit;
			}

			return {
				...item,
				unit_measurement: unitMeasurement,
				units_enabled: units,
				value_unit_measurement: item.value_unit_measurement || 1000,
			};
		});

		setData((prevData) => ({ ...prevData, items: newItems }));
		setReload(false);
		// eslint-disable-next-line
	}, [reload, data.items?.length, units_measurement]);

	useEffect(() => {
		const newNet = _.sumBy(data.items, (item) => Number(String(item.price_total).replaceAll(",", ".")));
		setNet(String(newNet).replaceAll(".", ","));

		if (data.items.length === 0 && products.length > 0) {
			handleAddItem();
		}
		// eslint-disable-next-line
	}, [data.items, products.length]);

	const handleAddItem = () => {
		let newItems = [...data.items];
		newItems.push({
			product_id: "",
			tradename: "",
			text_product: "",
			quantity: "",
			container_content: "",
			unit_measurement: "",
			value_unit_measurement: "",
			price_total: "",
			price_unit: "",
			expiration_date: "",
			type_product: "",
		});
		setData({ ...data, items: newItems });
	};

	const changeTextProduct = (i, value) => {
		let newItems = [...data.items];
		newItems[i].text_product = value;
		setData({ ...data, items: newItems });
	};

	const changeProduct = (i, opt, _meta) => {
		let value = "";
		let unit_measurement = "";
		let newItems = [...data.items];

		if (opt) {
			value = opt.value;

			const product = products.find((p) => Number(p.value) === Number(value));

			if (product) {
				unit_measurement = product.unit_measurement;
			} else if (!products.find((p) => p.value === value)) {
				const newProduct = {
					label: value,
					value: value,
					unit_measurement: "",
				};

				let newProducts = [...products];
				newProducts.push(newProduct);

				setProducts(newProducts);
			}
		}

		newItems[i].unit_measurement = unit_measurement;
		newItems[i].value_unit_measurement = "";
		newItems[i].product_id = value;

		setData({ ...data, items: newItems });
		setReload(true);
	};

	const changeQuantity = (i, value) => {
		let newItems = [...data.items];
		newItems[i].quantity = value;
		setData({ ...data, items: newItems });
	};

	const changeContainerContent = (i, value) => {
		value = String(value).replaceAll(".", "");

		let newItems = [...data.items];
		newItems[i].container_content = value;
		setData({ ...data, items: newItems });
	};

	const changeUnitMeasurement = (i, value) => {
		let newItems = [...data.items];

		if (String(value).includes("c")) {
			newItems[i].unit_measurement = "cc";
		}
		if (String(value).includes("g")) {
			newItems[i].unit_measurement = "g";
		}
		if (String(value).includes("u")) {
			newItems[i].unit_measurement = "u";
		}

		newItems[i].value_unit_measurement = value;
		setData({ ...data, items: newItems });
	};

	const changePrice = (i, value) => {
		value = String(value).replaceAll(".", "");

		let newItems = [...data.items];
		newItems[i].price_total = value;

		if (data && data.items[i]["quantity"] !== 0) {
			newItems[i]["price_unit"] = parseFloat(value.replaceAll(",", ".")) / data.items[i]["quantity"];
		}
		setData({ ...data, items: newItems });
	};

	const changeTypeProduct = (i, value) => {
		let newItems = [...data.items];
		newItems[i].type_product = value;
		setData({ ...data, items: newItems });
	};

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeProduct && "active"}>
				<Card.Header onClick={() => setActiveProduct(!activeProduct)} className={activeProduct && "active"}>
					Productos
					<div>
						<span>
							<strong> Precio Total:</strong> ${formatMilesDecimalNew(net)}
						</span>
					</div>
				</Card.Header>

				{activeProduct && (
					<>
						<Card.Body>
							<CreateOrderTableHead />
							<Row className={classes.body_table}>
								<Col md={12} sm={12}>
									<CreateOrderTableItem
										data={data}
										setData={setData}
										products={products}
										changeTextProduct={changeTextProduct}
										changeProduct={changeProduct}
										changeQuantity={changeQuantity}
										changeContainerContent={changeContainerContent}
										changeUnitMeasurement={changeUnitMeasurement}
										changePrice={changePrice}
										changeTypeProduct={changeTypeProduct}
									/>
								</Col>
							</Row>
						</Card.Body>
						<Card.Footer>
							<AddIcon className={classes.iconAdd} onClick={() => handleAddItem()} />
						</Card.Footer>
					</>
				)}
			</Card>
		</Col>
	);
};

export default CreateOrderTableDetail;
